var $ = global.jQuery = global.$;

var widgets = require('../lib/widgets');

require('../third-party/jquery.validate');
require('../third-party/additional-methods');

$.validator.addMethod('email', function(value, element) {
  // allow any non-whitespace characters as the host part
  return this.optional( element ) || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test( value );
}, 'Please enter a valid email address.');
$.validator.addMethod('phone', function(value, element) {
  // allow any non-whitespace characters as the host part
  return this.optional( element ) || /^\d{10,11}$/.test( value );
}, 'Please enter a valid phone number. Number should be 10 or 11 characters and contain only digits');
// $.validator.addMethod('postcode', function(value, element) {
//   // allow any non-whitespace characters as the host part
//   return this.optional( element ) || /^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/.test( value );
// }, 'Please enter a valid UK postal code');
$.validator.addMethod('strongpassword', function(value, element) {
  return this.optional( element ) || /^(?=.*[A-Z])(?=.*\d)(?=.*[$@!%*#?\-_~`^\(\)+=&])[A-Za-z\d$@!%*#?\-_~`^\(\)+=&]{8,}$/.test( value );
}, 'Your password should be at least 8 characters in length and contain one uppercase character, one number and one special character ($@!%*#?\-_~`^\()+=&)');

var _Base = require('./_Base');

/**
 * Form widget
 * @class
 * @extends _Base
 */
var Form = _Base.extend(
  /** @lends Form.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;
    this.fields = {};
    this.isDisabled = false;
    this.action = this.$el.prop('action');
    this.inlineRules = this.$el.data('validationRules');

    this.customValidation = this.customValidation || {};

    this.customValidation = this.inlineRules ? $.extend(this.inlineRules, this.customValidation) : this.customValidation;

    this.customValidation.highlight = function(element, errorClass, validClass) {
      $(element).addClass(errorClass).removeClass(validClass);
      $(element).parents('.field').addClass(errorClass).removeClass(validClass);
      self.$el.trigger('Element:Resize');
    };
    this.customValidation.unhighlight = function(element, errorClass, validClass) {
      $(element).removeClass(errorClass).addClass(validClass);
      $(element).parents('.field').removeClass(errorClass).addClass(validClass);
      self.$el.trigger('Element:Resize');
    };

    this.validator = this.$el.validate(this.customValidation);
    this.$el.on('Field:Updated', this, function(event, name, value) {
      self._fieldRegistryUpdate.call(self, event, name, value);
    });

    this.$el.on('submit', this._formSubmitHandler.bind(this));
  },
  onWidgetsReady: function() {
    this.fieldWidgets = widgets.getDescendants(this.$el, 'Field');
  },
  reset: function() {
    var self = this;
    if (this.$el.get(0).reset) this.$el.get(0).reset();
    this.validator.resetForm();
  },
  /**
   * Handle form submission
   * @private
   */
  _formSubmitHandler: function(event) {
    if (this.isDisabled === false) {
      this.$el.trigger('Form:Submitted', [this.getFieldValues()]);
    }
  },
  /**
   * Update field registry
   * @private
   */
  _fieldRegistryUpdate: function(event, name, value) {
    event.stopPropagation();
    this.fields[name] = {};
    this.fields[name].value = value;
  },
  /**
   * Set values of the forms fields to the new values
   * @param {Object} newValues - An object of key value pairs corresponding to field names and values to update.
   */
  setFieldValues: function(newValues) {
    $.each(this.fieldWidgets, function() {
      if (newValues.hasOwnProperty(this.name)) this.setValue(newValues[this.name]);
    });
  },
  /**
   * Get values of all child fields
   * @returns {Object} An object of key value pairs of form field values
   */
  getFieldValues: function() {
    var fields = {};
    $.each(this.fieldWidgets, function() {
      fields[this.name] = this.getValue();
    });
    return fields;
  }
});

module.exports = Form;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/Form.js
// module id = 64
// module chunks = 0